import { Card, Form } from 'antd';
import React from 'react'

function BankInformation({data}) {
  return (
    <Card title="Bank Information">
      <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 8}}>
        <Form.Item label="Bank Name">
            <p>{data?.bankName}</p>
        </Form.Item>
        <Form.Item label="Description">
            <p>{data?.description}</p>
        </Form.Item>
        <Form.Item label="Routing Number">
            <p>{data?.routingNumber}</p>
        </Form.Item>
        <Form.Item label="Account Number">
            <p>{data?.accountNumber}</p>
        </Form.Item>
        <Form.Item label="Use Printable Deposit Slip">
            <p>{data?.usePrintablDepositSlip}</p>
        </Form.Item>
        <Form.Item label="Address">
            <p>{data?.address}</p>
        </Form.Item>
        <Form.Item label="Payments Enabled">
            <p>{data?.paymentsEnabled}</p>
        </Form.Item>
        <Form.Item label="Verified by Plaid for Online Payments">
            <p>{data?.verifiedOnlinePayments}</p>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default BankInformation;
